import {
  AUTH_TOKEN_SESSION_KEY,
  AUTH_TOKEN_HEADER_NAME,
  GLOBAL_RESTOR_HEADER_NAME,
  TV_MODE_TOKEN
} from '../../constants/UserManagementConstants';

export function GetDefaultHeaders() {
  let authToken = JSON.parse(localStorage.getItem(AUTH_TOKEN_SESSION_KEY));
  let headers = { 'Content-Type': 'application/json' };
  headers[AUTH_TOKEN_HEADER_NAME] = authToken;
  return headers;
}
export function GetGlobalHeaders(clientId) {
  if (!clientId) throw 'need to insert clientId Number';
  let authToken = JSON.parse(localStorage.getItem(AUTH_TOKEN_SESSION_KEY));
  let headers = { 'Content-Type': 'application/json' };
  headers[AUTH_TOKEN_HEADER_NAME] = authToken;
  headers[GLOBAL_RESTOR_HEADER_NAME] = clientId;
  return headers;
}

export function GetAuthTokenHeader() {
  let authToken = JSON.parse(localStorage.getItem(AUTH_TOKEN_SESSION_KEY));
  let headers = {};
  headers[AUTH_TOKEN_HEADER_NAME] = authToken;
  return headers;
}

export function GetTvModeTokenHeader() {
  let TvModeToken = localStorage.getItem(TV_MODE_TOKEN);
  let headers = { 'Content-Type': 'application/json' };
  headers[TV_MODE_TOKEN] = TvModeToken;
  return headers;
}
